import { render } from "./LandingView.vue?vue&type=template&id=5df45281&scoped=true"
import script from "./LandingView.vue?vue&type=script&lang=js"
export * from "./LandingView.vue?vue&type=script&lang=js"

import "./LandingView.vue?vue&type=style&index=0&id=5df45281&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df45281"]])

export default __exports__